module.exports = __webpack_public_path__ + "img/06.b44932c0.jpg";